import { useCallback } from 'react';


export interface UseSearchActionOptions {
  /**
   * Function to fetch data. Should accept a page number.
   */
  fetchData: (page?: number) => Promise<void>;
  /**
   * Function to set the current page.
   */
  setPage: (page: number) => void;
}

/**
 * Hook to handle manual search actions (e.g. clicking a "Search" button).
 * Resets pagination to page 1 and triggers data fetching.
 */
export const useSearchAction = ({ fetchData, setPage }: UseSearchActionOptions) => {
  const handleSearch = useCallback(() => {
    setPage(1);
    // IIFE to handle async execution without void operator issues
    void (async () => {
      try {
        await fetchData(1);
      } catch {
        // Error handled by fetchData or ignored
      }
    })();
  }, [fetchData, setPage]);

  return { handleSearch };
};
